
  import { defineComponent, ref, computed, watch, onMounted } from 'vue';
  import { useStore } from 'vuex';
  import { Actions } from '@/store/enums/StoreEnums';
  import { useI18n } from 'vue-i18n/index';

  export default defineComponent({
    name: 'ads-filter',
    emit: ['type-selected', 'reset'],
    setup(_, { emit }) {
      const { t, te } = useI18n();
      const store = useStore();
      const selectedItems = ref<any>({
        status: '',
        phone: '965',
        paymentMethod: '',
        service: '',
        packageName: '',
        chargeId: '',
        platform: '',
      });

      const translate = (text: string) => (te(text) ? t(text) : text);

      const onSubmit = () => {
        emit('type-selected', { ...selectedItems.value });
      };

      const onReset = () => {
        selectedItems.value = {
          status: '',
          phone: '965',
          paymentMethod: '',
          service: '',
          packageName: '',
          chargeId: '',
          platform: '',
        };
        emit('reset', selectedItems.value);
      };

      onMounted(async () => {
        await store.dispatch(Actions.GET_PACKAGES, { limit: 50 });
        const fillter = store.getters.getChargesLogsFilter;
        if (
          fillter?.phone !== undefined &&
          fillter?.phone !== null &&
          fillter?.phone !== '' &&
          !isNaN(fillter.phone)
        ) {
          selectedItems.value.phone = String(fillter.phone);
        }
        if (fillter?.status !== '' && fillter?.status !== 'undefined') {
          selectedItems.value.status = fillter.status;
        }
        if (
          fillter?.paymentMethod !== '' &&
          fillter?.paymentMethod !== 'undefined'
        ) {
          selectedItems.value.paymentMethod = fillter.paymentMethod;
        }
        if (fillter?.service !== '' && fillter?.service !== 'undefined') {
          selectedItems.value.service = fillter.service;
        }
        if (
          fillter?.packageName !== '' &&
          fillter?.packageName !== 'undefined'
        ) {
          selectedItems.value.packageName = fillter.packageName;
        }
        if (fillter?.platform !== '' && fillter?.platform !== 'undefined') {
          selectedItems.value.platform = fillter.platform;
        }
        if (fillter?.chargeId !== '' && fillter?.chargeId !== 'undefined') {
          selectedItems.value.chargeId = fillter.chargeId;
        }
      });

      return {
        adTypes: computed(() => store.getters.adTypesAllList),
        adsPackages: computed(() => store.getters.adsPackagesList),
        onSubmit,
        onReset,
        translate,
        selectedItems,
        packages: computed(() => store.getters.packagesList),
      };
    },
  });
